<script>
    // @ts-nocheck
    import { Router, Route, navigate, useLocation } from 'svelte-navigator'
    import { fly, fade, slide } from 'svelte/transition'
    import searchlogo from '../assets/pictures/search.svg'
    import {
        clickOutside,
        sortBy,
        strftime,
        formatCUIT,
        areasOrder,
        isPdf,
    } from '$lib/utils'
    import {
        buildFilterCompilator,
        isoDateFilterTimestamp,
        multiKeyFilter,
    } from '$lib/services/dynamicFilters'
    import { API_URL, ENV } from '$lib/conf'
    import dictionaries from '$lib/stores/dictionaries'
    import user from '$lib/stores/user'
    import { writable } from 'svelte/store'
    import provider from '$lib/stores/provider'
    import waitingDocuments from '$lib/stores/countWaiting'
    import { currencyFormatter } from '$lib/utils'
    import { onMount, onDestroy } from 'svelte'
    import { Invoice } from '$lib/services/interfaces'
    import { db } from '$lib/services/db'
    import { liveQuery } from '$lib/services/livequery'
    import TopBar from '$lib/components/layout/TopBar.svelte'
    import PerceptionsTable from '$lib/custom/components/PerceptionsTable.svelte'
    import FacturasGeneralesLoader from '$lib/custom/components/FacturasGeneralesLoader.svelte'
    import {
        Banner,
        ScrollBox,
        Typography,
        TertiaryButton,
        FormBoxContainer,
        Datatable,
        FormBoxRow,
        FormBoxCell,
        BackDrop,
        SelectX,
        Row,
        Column,
        InputFile,
        InputText,
        InputTag,
        InputDate,
        Alert,
        Spinner,
        Skeleton,
        Paginator,
        Chip,
        Button,
    } from '$lib/components/UI/'
    import { SyncOutline } from '$lib/components/Icons'
    import { default as filterIcon } from '../assets/pictures/f28-filter-funnel.svg'
    import { default as notFoundDoc } from '../assets/pictures/f64-printer.svg'
    import Docs from '$lib/components/Icons/custom/Docs.svelte'
    import DatatableX from '$lib/components/UI/DatatableX.svelte'
    import Upload from '$lib/components/Icons/custom/Upload.svelte'
    import Close from '$lib/components/Icons/custom/Close.svelte'
    import InvoiceTableHeader from '$lib/custom/components/InvoiceTableHeader.svelte'
    let dynamicFilter = [] // Arreglo de tuplas [assert<Bool>, filter<Function>]
    let showFilters = false
    let dataFilter = {
        id: '',
        fc_desde: 0,
        'source.organizeImports': true,
        fc_hasta: 0,
    }
    let siteUrl = ENV.API_URL.split('/').slice(0, -1).join('/')
    const company = {
        '1000': 'CAJA DE SEGUROS SA',
        '1001': 'RITENERE SA',
        '1002': 'CAJA DE AHORRO Y SEGURO SA',
        '3050101001': 'UNKNOW',
    }
    const maskState = {}
    const getState = (state) => {
        let prop = state in refStates
            ? refStates[state]
            : { label: state, color: 'gray' }
        let {label: estado} = prop
        if (estado) estado = estado in maskState ? maskState[estado] : estado
        return {...prop, label: estado || state}
    }
    let currentPage
    function getDate(date, type = 'locale') {
        if (typeof date === 'number') {
            let tmpDate = new Date(date * 1000)
            if (type === 'locale') {
                return `${String(tmpDate.getDate()).padStart(2, '0')}/${String(tmpDate.getMonth() + 1).padStart(2, '0')}/${tmpDate.getFullYear()}`
            } else if (type === 'iso') {
                return `${tmpDate.getFullYear()}-${String(tmpDate.getMonth() + 1).padStart(2, '0')}-${String(tmpDate.getDate()).padStart(2, '0')}`
            } else {
                return ''
            }
        } else {
            return ''
        }
    }
/*{
            'Ingresada': (
                'Factura Ingresada',
            ),
            # 'En trámite': (
            # ),
            'A Completar': (
                'Factura en Proveedor',
                'Factura Incompleta'
            ),
            'Rechazada': ('Factura Rechazada'),
            # 'Pendiente': ('Factura en Proveedor'),
            'Aprobada': (
                'Factura Enviada',
                'Factura Procesada'
            ),
            'En Revisión': ('Revision Polaris'),
            'Pagada': ('Factura Pagada')
        }*/
    const refStates = {
        Ingresada: { alt: 'Factura ingresada', color: '#6F7072', icon: '' },
        'En tramite': {
            alt: 'Factura en trámite de aprobación, está siendo procesada.',
            label: 'En trámite',
            color: '#FF9F00',
            icon: '',
        },
        Rechazada: {
            alt: 'La factura fué rechazada.',
            label: 'Rechazada',
            color: '#AF2219',
            icon: '',
        },
        'En liquidacion': {
            alt: 'En proceso de liquidación.',
            label: 'En liquidación',
            color: '#FF9F00',
            icon: '',
        },
        Aprobada: {
            alt: 'Su pago fué aprobado.',
            color: '#7ED321',
            icon: '',
        },
        'Fondos Transferidos': {
            alt: 'El pago de la factura ha sido realizado.',
            color: '#7ED321',
            icon: '',
        },
    }
    let sortDirective = writable(['fecha_creacion'])
    const invoices = liveQuery(db.invoices_sin, Invoice)
    const location = useLocation()
    const getRegex = (v, f = '') => {
        return new RegExp(v, f)
    }
    const filterCompilator = buildFilterCompilator((t) =>
        t.where('id_proveedor').equals($user?.currentIdAccount)
    )
    function search(val) {
        currentPage = 1
        dynamicFilter = [
            [
                true, //   Assert (default search)
                (f) =>
                    f.filter((item) => {
                        // Custom filter (default search)
                        return (
                            [
                                'punto_venta',
                                'id',
                                'estado',
                                'npo_factura',
                                'punto_venta',
                                'total'
                            ].some((x) =>
                                getRegex(
                                    `${val.replace(/[^\x00-\x7F]+/g, '.')}`,
                                    'i'
                                ).test(item[x])
                            ) ||
                            getRegex(val).test(getDate(item.fecha_creacion))
                        )
                    }),
            ],
        ]
        if (val == '') {
            clearFilter()
        }
    }
    let inputValue = ''
    let isValidAttachment = false
    $: visible = $location.pathname !== '/home/invoices'
    const clearFilter = (_) => {
        inputValue = ''
        dynamicFilter = [] // clear filters
    }
    const autorefresh = setInterval((_) => {
        invoices.sync()
    }, 300000)

    onMount((_) => {
        autorefresh
        setTimeout((_) => {
            invoices.sync()
        }, 1500)
        return () => clearInterval(autorefresh)
    })

    // onDestroy((_) => {
    //     clearInterval(autorefresh)
    // })
    const schema_percepciones = {
        provincia: {
            render: (v) =>
                $dictionaries.vprovincias?.find((t) => t.value === v)
                    ?.label || '',
        },
        desc: {
            label: 'Descripcion',
            render: (_, item) =>
                $dictionaries.lic_percepciones?.find(
                    (t) => t.value === item?.percepcion
                )?.label || '',
        },
        // percepcion: {
        //     label: 'Percepción',
        // },
        monto: {
            label: 'Monto',
            render: (n) =>
                n ? currencyFormatter({ n, type: 'ARS', lang: 'es-AR' }) : '-',
        },
    }
    let dataForm = { ivap: 0.21 }
    $: if ($provider || dataForm) {
        dataForm.email = $provider.data.email_dp
    }

    async function sendInvoice(data=null) {
        await Invoice.add(data || dataForm)
            .then(async (r) => {
                waitingDocuments.append(-1)
                if (r.ok) {
                    let item = await r.json()
                    invoices.add(item).then((r) => {
                        console.log('Promise Collection')
                    })
                    return r
                } else {
                    throw new Error('Falla al subir factura')
                }
            })
            .catch((_) => waitingDocuments.append(-1))
        waitingDocuments.append(1)
        clearForm()
    }
    let validOC = true
    let ocInp = ''
    let paginatorObj = {}
    $: if (showFilters === true) {
        dynamicFilter = [
            multiKeyFilter(dataFilter?.id || '', ['id_ath', 'ref']),
            isoDateFilterTimestamp(
                [dataFilter?.fc_desde || null, dataFilter?.fc_hasta || null],
                'fecha_creacion'
            ),
        ]
    }
    // $: dynamicFilter = [
    //         multiKeyFilter(dataFilter.id || '', ['id_ath', 'ref']),
    //         isoDateFilterTimestamp([dataFilter?.fc_desde || null, dataFilter?.fc_hasta || null], 'fecha_creacion')
    // ];
    // $: if(`${JSON.stringify(dynamicFilter)}`){
    //     currentPage = 1;
    // };
    function getInvoiceId() {
        return Array(8)
            .fill('')
            .map(() => String.fromCharCode(32 + Math.ceil(Math.random() * 94)))
            .join('')
    }
    let invoiceId = getInvoiceId()
    function clearForm() {
        console?.clear && console.clear()
        dataForm = {}
        invoiceId = getInvoiceId()
    }
    $: areasList =
        $dictionaries?.areas?.sort((a, b) => {
            let x = areasOrder.indexOf(a?.label)
            let y = areasOrder.indexOf(b?.label)
            return x > y ? 1 : -1
        }) || []
    $: if (showFilters === false) {
        clearFilter()
    }
    $: invoices.liveQuery(filterCompilator(dynamicFilter, $sortDirective)) // Reactive filter
    $: validInvoiceData =
        Object.entries(dataForm).every(([k, x]) => {
            return (x && typeof x === 'string' ? x.length > 0 : x) || k === 'orden_de_compra'
        }) && isValidAttachment;
    // $: console.log({isValidAttachment, dataForm, validInvoiceData})
    // $: if (dataForm) {
    //     console?.clear && console.clear()
    //     console.log(JSON.stringify(dataForm, null, 4))
    //
    let currentItem
    $: console.log({dataForm, currentItem})
    let IVAP = 0.21
</script>

<div
    style="width: 100%; padding: 50px 70px; display: flex; flex-direction:column; align-items: center; gap: 20px; position: relative"
>
    <Router primary={false}>
        <FacturasGeneralesLoader bind:value={dataForm} callbackSend={async () => {await sendInvoice()}} />
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <FormBoxContainer title="Mis Facturas" icon={Docs}>
            <svelte:fragment slot="option">
                <!-- <img width="32px" src={filterIcon} alt=""> -->
                <span
                    on:click={(_) =>
                        invoices.sync({ cuit: $user?.defaultAccount })}
                    title="Sincronizar"
                >
                    <SyncOutline size={25} />
                </span>
                <span on:click={(_) => (showFilters = !showFilters)}>
                    {#if !showFilters}
                        <img
                            src={filterIcon}
                            title="Filtros"
                            width="25px"
                            alt="Filtros"
                        />
                    {:else}
                        <Close color="#00669E" />
                    {/if}
                </span>
            </svelte:fragment>
            {#await invoices.init()}
                <span
                    style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center"
                >
                    <Spinner />
                </span>
            {:then _}
                {#if showFilters}
                    <span style="padding: 24px">
                        <Typography type="subhead">Identificador</Typography>
                        <Row>
                            <InputText
                                on:keyup={(_) => (currentPage = 1)}
                                bind:value={dataFilter.id}
                            />
                        </Row>
                        <Typography type="subhead">Fecha de creación</Typography
                        >
                        <Row>
                            <InputDate
                                on:change={(_) => (currentPage = 1)}
                                label="Desde"
                                bind:value={dataFilter.fc_desde}
                            />
                            <InputDate
                                on:change={(_) => (currentPage = 1)}
                                label="Hasta"
                                bind:value={dataFilter.fc_hasta}
                            />
                        </Row>
                        {#if !([dataFilter.fc_desde, dataFilter.fc_hasta].every((t) => t !== undefined && typeof t === 'string' && t !== '') && dataFilter.fc_hasta.localeCompare(dataFilter.fc_desde) !== -1)}
                            <Alert type="error"
                                >"Hasta" debe ser posterior a "Desde"</Alert
                            >
                        {/if}
                        <p>
                            Resultados totales: <strong
                                >{$invoices.length}</strong
                            >
                        </p>
                        <!-- <Chip color="grey">Resultados totales: {$invoices.length}</Chip> -->
                    </span>
                {:else}
                    <span class="search">
                        <img src={searchlogo} alt="" draggable="false" />
                        <input
                            type="search"
                            placeholder="Buscar"
                            bind:value={inputValue}
                            on:input={(_) => search(inputValue)}
                        />
                    </span>
                {/if}
                <Datatable
                    data={invoices}
                    bind:pagination={paginatorObj}
                    bind:currentPage
                    waitingSignals={waitingDocuments}
                >
                    <svelte:fragment slot="header">
                        <InvoiceTableHeader bind:sortDirective />
                    </svelte:fragment>
                    <svelte:fragment slot="body" let:item={invoice}>
                        <tr>
                            <td
                                ><Typography
                                    style="margin: 0; padding: 0"
                                    type="body"
                                    color="grey-800"
                                    >{invoice.no_factura.match(/[0]{13}/)
                                        ? '...'
                                        : invoice.no_factura}</Typography
                                ></td
                            >
                            <td
                                ><Typography
                                    style="margin: 0; padding: 0"
                                    type="body"
                                    color="grey-800"
                                    >{new Date(invoice.creation_date).toLocaleDateString()}</Typography
                                ></td
                            >
                            <td
                                ><Typography
                                    style="margin: 0; padding: 0"
                                    type="body"
                                    color="grey-800"
                                    >{invoice.total > 0
                                        ? currencyFormatter({
                                              n: invoice.total,
                                              lang: 'es-AR',
                                              type: 'ARS',
                                          })
                                        : '...'}</Typography
                                ></td
                            >
                            <td
                                ><Chip
                                    label={invoice.state}
                                    {...refStates[invoice.state]}
                                /></td
                            >
                            <td
                                ><Typography
                                    style="margin: 0; padding: 0"
                                    type="body"
                                    color="grey-800"
                                    ><TertiaryButton
                                        on:click={(_) => {
                                        currentItem = invoice;
                                        navigate(`invoices/${invoice.id}`, {
                                            state: {
                                                ref: '/home/invoices',
                                            },
                                        })}}
                                        label="Ver detalle"
                                    /></Typography
                                ></td
                            >
                        </tr>
                    </svelte:fragment>
                    <svelte:fragment slot="skeleton">
                        <tr
                            in:slide
                            class="row"
                            title="La información sera visible pronto"
                        >
                            <td
                                ><Skeleton
                                    style="opacity: 0.80; height: 21px; max-width: 145px"
                                /></td
                            >
                            <td
                                ><Skeleton
                                    style="opacity: 0.80; height: 21px; max-width: 95px"
                                /></td
                            >
                            <td
                                ><Skeleton
                                    style="opacity: 0.80; height: 21px"
                                /></td
                            >
                            <td
                                ><Skeleton
                                    style="opacity: 0.80; height: 21px; max-width: 80px"
                                /></td
                            >
                            <td
                                ><TertiaryButton
                                    label="Ver detalle"
                                    disabled
                                /></td
                            >
                        </tr>
                    </svelte:fragment>
                    <svelte:fragment slot="noContent">
                        <img
                            src={notFoundDoc}
                            height="75px"
                            alt=""
                            style="margin: 0;padding:0; width: auto"
                        />
                        <Typography style="margin: 0; padding: 0" type="body"
                            >No se encontraron Facturas.</Typography
                        >
                    </svelte:fragment>
                </Datatable>
            {/await}
        </FormBoxContainer>
        {#if ($invoices || []).length > 0}
            <Paginator {...paginatorObj} bind:currentPage />
        {/if}
        <Route path="/:id" let:params>
            <BackDrop style="z-index: 999999; position: fixed" {visible}>
            <div
                class="drawer"
                transition:fly={{ x: 50 }}
                use:clickOutside
                on:clickout={(_) => navigate('/home/invoices')}
            >
                <TopBar
                    title="Detalle de Factura"
                    on:back={(_) => navigate($location?.state?.ref || -1)}
                >
                    <!-- <svelte:fragment slot="bar">
                        <Button
                            label="Ir a la oferta"
                            size="small"
                            type="transparent"
                            style="margin: 0 15px 0 0"
                            on:click={() => {
                                currentItem ? user.navigate(`/home/ofertas/${currentItem.offer.id}/view`) : navigate(-1)
                            }}
                        />
                    </svelte:fragment> -->
                    {#await invoices.get(params.id, true)}
                        <Spinner />
                    {:then invoice}
                        <!-- {@const percepciones = invoice.percepcion ? invoice.percepcion.split('|') : []} -->
                        <div
                            transition:fade|local
                            style="position: absolute;width: 100%; height: 100%; display: flex; flex-direction: column; position: relative"
                        >
                            <Banner
                                title={`FACT ${invoice.no_factura}`}
                                label="factura"
                                style=""
                                info={[
                                    {
                                        label: 'CUIT',
                                        value:
                                            formatCUIT(
                                                invoice.cuit_proveedor
                                            ).replace(/\s/g, '') || '-',
                                    },
                                    {
                                        label: 'Fecha de ingreso',
                                        value: strftime(
                                            '%d/%m/%Y',
                                            new Date(invoice.creation_date)
                                        ),
                                    },
                                    {
                                        label: 'Fecha de facturación',
                                        value: invoice.fecha_factura
                                            ? strftime(
                                                  '%d/%m/%Y',
                                                  new Date(
                                                      invoice.fecha_factura
                                                  )
                                              )
                                            : '...',
                                    },
                                    {
                                        label: 'Estado',
                                        value: getState(invoice.state).label
                                    },
                                ]}
                            />
                            <ScrollBox width="100%" height="calc(100% - 60px)">
                                <!-- height="calc(100% - 43px)" -->
                                <span
                                    style="padding:32px 70px; gap: 14px; display: flex; flex-direction: column; flex-wrap: wrap"
                                >
                                    {#if invoice.state == 'Rechazada'}
                                        <Alert type="error">
                                            <span
                                                style="display: flex; flex-direction: rows; justify-content: space-between"
                                            >
                                                <span>
                                                    <Typography
                                                        style="margin: 0 0 5px 0"
                                                        type="subtitle-medium"
                                                        >Motivos de rechazo:</Typography
                                                    >
                                                    {@html invoice.motivo_rechazo
                                                        .split('\n')
                                                        .map(
                                                            (i) =>
                                                                `<li>${i}</li>`
                                                        )
                                                        .join('\n')}
                                                </span>
                                                <!-- <Button
                                                    disabled={invoice.reemplazada}
                                                    style="margin: auto 0"
                                                    on:click={() =>
                                                        (currentItem = {
                                                            ...invoice,
                                                            file: [],
                                                            insteadOf:
                                                                invoice.id,
                                                        })}
                                                    label="Cargar otra"
                                                    size="small"
                                                /> -->
                                            </span>
                                        </Alert>
                                    {/if}
                                    <FormBoxContainer
                                        title="Información de la Factura"
                                    >
                                        <!-- <FormBoxRow>
                                            <FormBoxCell
                                                label="Patente"
                                                value={formatPatente(
                                                    invoice.patente
                                                )}
                                            />
                                        </FormBoxRow> -->
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="Nro. de Comprobante"
                                                value={invoice.no_factura
                                                    ? invoice.no_factura.padStart(
                                                          8,
                                                          '0'
                                                      )
                                                    : '...'}
                                            />
                                            <FormBoxCell
                                                label="Punto de Venta"
                                                value={invoice.punto_venta
                                                    ? invoice.punto_venta.padStart(
                                                          5,
                                                          '0'
                                                      )
                                                    : '...'}
                                            />
                                        </FormBoxRow>
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="Tipo de Factura"
                                                value={invoice.letra || '...'}
                                            />
                                            <FormBoxCell
                                                label="CAE/CAI"
                                                value={invoice.cae || '...'}
                                            />
                                            <FormBoxCell
                                                label="Fecha de vencimiento CAE"
                                                value={invoice.vencimiento_cae ||
                                                    '...'}
                                            />
                                        </FormBoxRow>
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="CUIT de Facturación"
                                                value={invoice.cuit_destinatario ||
                                                    '...'}
                                            />
                                        </FormBoxRow>
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="IVA"
                                                value={typeof invoice.iva === 'number' && invoice.iva >= 0
                                                    ? currencyFormatter({
                                                          n: invoice.iva,
                                                          lang: 'es-AR',
                                                          type: 'ARS',
                                                      })
                                                      //+ ` (${Math.ceil((invoice.iva / invoice.subtotal) * 100)}%)`
                                                    : '...'}
                                            />
                                            <FormBoxCell
                                                label="Subtotal"
                                                value={invoice.subtotal
                                                    ? currencyFormatter({
                                                          n: invoice.subtotal,
                                                          lang: 'es-AR',
                                                          type: 'ARS',
                                                      })
                                                    : '...'}
                                            />
                                            <FormBoxCell
                                                label="Importe Total"
                                                value={invoice.total
                                                    ? currencyFormatter({
                                                          n: invoice.total,
                                                          lang: 'es-AR',
                                                          type: 'ARS',
                                                      })
                                                    : '...'}
                                            />
                                        </FormBoxRow>
                                        {#if invoice.orden_de_compra?.length}
                                            <FormBoxRow>
                                                <FormBoxCell label="Ordenes de compra">
                                                    {#each invoice.orden_de_compra as orden}
                                                        <Chip color="grey">{orden['numero de orden']}</Chip>
                                                    {/each}
                                                </FormBoxCell>
                                            </FormBoxRow>
                                        {/if}
                                        {#if ENV.DEV}
                                            <FormBoxRow>
                                                <FormBoxCell>
                                                    <a
                                                        href={`${siteUrl}/file/view/${params.id}`}
                                                        target="_blank"
                                                        >{`${siteUrl}/file/view/${params.id}`}</a
                                                    >
                                                    <!-- <Link on:click={() => {
                                                        user.navigate(`${siteUrl}/file/view/${params.id}`, '_blank')
                                                    }}>{`${siteUrl}/file/view/${params.id}`}</Link> -->
                                                </FormBoxCell>
                                            </FormBoxRow>
                                        {/if}
                                    </FormBoxContainer>
                                    {#if invoice.percepcion.length > 0}
                                        <Typography style="margin-bottom: 0px"
                                            >Percepciones</Typography
                                        >
                                        <DatatableX
                                            initialData={invoice.percepcion}
                                            schema={schema_percepciones}
                                        />
                                        <!-- <span style="width: auto; margin: 0 0 25px 0; display: flex; gap: 10px; flex-wrap: wrap">
                                                {#each percepciones as perc}
                                                    <Chip style="border-radius: 5px; background: grey" alt={perc}>
                                                        {($dictionaries.lic_percepciones || []).find(t=> t.value === perc)?.label || 'Unknow'}
                                                    </Chip>
                                                {/each}
                                            </span> -->
                                    {/if}
                                    <Alert type="info"
                                        >En caso de duda, comunicarse con el
                                        área a la cual se brindó el servicio.</Alert
                                    >
                                    <span class="buttonSet">
                                        <Button
                                            label="Descargar"
                                            style="width: 100%"
                                            on:click={(_) =>
                                                window.open(
                                                    `${API_URL}/download/${invoice.id}`
                                                )}
                                        />
                                    </span>
                                </span>
                            </ScrollBox>
                        </div>
                    {:catch}
                        <Alert type="error"
                            >La factura no existe o no tienes permisos para
                            verla.</Alert
                        >
                    {/await}
                </TopBar>
            </div>
        </BackDrop>
        </Route>
    </Router>
</div>

<style>
    .drawer {
        position: absolute;
        min-width: 500px;
        width: 100%;
        max-width: 978px;
        right: 0;
        top: 0;
        height: 100%;
        background-color: #f6f6f6;
    }
    .search {
        width: 100%;
        height: 72px;
        position: relative;
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        padding: 0 25px;
        justify-content: flex-start;
    }
    .search input {
        border-style: none;
        outline: none;
        font-size: 17px;
        width: 100%;
    }

    .buttonSet {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
</style>
